import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;
};
export const dataGet7 = async () => {
    return data;
};
// export const getItems = () => {
//     return data;
// };
export const getItems7 = async (data2) =>  {
    data.length = 0;
    for (let i = 0; i <data2.length ; i++) {
            var RegistoProduto1 =  data2[i].contaCorrenteDesc;
            var Correlativa1 = data2[i].correlativa;
            var NLote1 = data2[i].numeroLote;
            var NGarrafas1 = data2[i].numeroGarrafasAE;
            var Capacidade1 = data2[i].capacidadeAE;
            var TotalQBD1 = data2[i].quantidadeAferida;
            var idContaCorrente1 =  data2[i].idContaCorrente;
            var idRegistoProduto1 = data2[i].idRegistoProduto;
            var idCapacidadeAE1 = data2[i].idCapacidadeAE;
            var idAutoDetalhe1 = data2[i].idAutoDetalhe;
            var idRotulo1 = data2[i].idRotulo;
            data.push({ 
                //CapacidadeNDNovo: Capacidade1 != null && idCapacidadeAE1 != null ? {text: Capacidade1 , value: idCapacidadeAE1} : null,
                RegistoProduto : RegistoProduto1,
                Correlativa : Correlativa1,
                NLote : NLote1,
                NGarrafas : NGarrafas1,
                CapacidadeND : Capacidade1,
                TotalQBD : TotalQBD1,
                ProductID: i,
                idContaCorrente : idContaCorrente1,
                idRegistoProduto: idRegistoProduto1,
                idCapacidadeAE: idCapacidadeAE1,
                idAutoDetalhe: idAutoDetalhe1,
                idRotulo: idRotulo1,
                Discontinued: false,
                Columns: [],
                inEdit: false
            })
    }
    return data;
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
